import Chart from 'chart.js/auto';
import { TreemapController, TreemapElement } from 'chartjs-chart-treemap';
import * as math from '../../js-handler/math';

Chart.register(TreemapController, TreemapElement);

const chartColor = require('./chart-color');

function leafFromDataItem(dataItem) {
    const d = dataItem && dataItem._data;
    if (!d) return null;
    if (Array.isArray(d.children) && d.children.length) return d.children[0];
    return d;
}

export function start(detail) {
    obj[detail.act].start(detail);
}

const obj = {
    createSimple: { start: (detail) => { createSimple(detail); } },
};

function createSimple(detail) {
    const datos = {
        label: 'Item',
        tree: detail.data,
        key: 'value',
        groups: ['name'], // Asegúrate de que esto coincida con la propiedad de tu data

        borderWidth: 3,
        spacing: 0.1,
        backgroundColor: (ctx) => {
            if (ctx.type !== 'data' || !ctx.raw) return 'transparent';
            return chartColor.paletteColorAt(ctx.dataIndex).backgroundColor;
        },
        hoverBackgroundColor: (ctx) => {
            if (ctx.type !== 'data' || !ctx.raw) return 'transparent';
            return chartColor.paletteColorAt(ctx.dataIndex).hoverBackgroundColor;
        },
        borderColor: (ctx) => {
            if (ctx.type !== 'data' || !ctx.raw) return 'transparent';
            return chartColor.paletteColorAt(ctx.dataIndex).borderColor;
        },
        labels: {
            display: true,
            color: 'white',
            font: { size: 14, weight: 'bold' },
            align: 'center',
            position: 'middle',
            formatter(ctx) {
                const leaf = leafFromDataItem(ctx.raw);
                if (!leaf) return '';
                const n = leaf.name != null ? leaf.name : '';
                const v = leaf.value != null ? leaf.value : '';
                const inversion = leaf.inversion != null ? leaf.inversion : '';
                const label = n ? [n, math.cashFormat(v)] : [String(math.cashFormat(v))];
                return label;
            },
        }
    }

    const setup = {
        type: 'treemap',
        data: {
            datasets: [datos]
        },
        options: {
            scales: {
                x: { display: false },
                y: { display: false }
            },
            
            plugins: {
                datalabels: {
                    display: false
                },
                title: {
                    display: false,
                    text: '' //titulo de la grafica
                },
                legend: {
                    display: false
                },

                tooltip: {
                    position: 'treemap',
                    intersect: true,
                    callbacks: {
                        title(items) {
                            if (!items.length) return '';
                            const di = items[0].dataset.data[items[0].dataIndex];
                            const leaf = leafFromDataItem(di);
                            if (!leaf) return '';
                            return leaf.fullName != null ? leaf.fullName : (leaf.name != null ? String(leaf.name) : '');
                        },
                        label(item) {
                            const di = item.dataset.data[item.dataIndex];
                            const leaf = leafFromDataItem(di);
                            if (!leaf) return '';
                            const qty = leaf.qty != null ? leaf.qty : 0;
                            const total = leaf.inventoryTotal != null ? leaf.inventoryTotal : 0;
                            const inversion = leaf.inversion != null ? math.cashFormat(leaf.inversion) : '';
                            return [
                                `Cantidad: ${qty}`,
                                `Inversión: ${inversion}`,
                            ];
                        },
                    },
                },
                
            }
        }
    };

    // Aplicar opciones externas sin romper las escalas
    if (detail.options) {
        optionsCheck(detail, setup);
    }

    detail.targetChart.chart = new Chart(detail.targetChart.html, setup);
}

function optionsCheck(detail, setup) {
    if (!detail.options) return;
    if (detail.options.aspectRatio !== undefined) setup.options.aspectRatio = detail.options.aspectRatio;
    if (detail.options.legend !== undefined) setup.options.plugins.legend.display = detail.options.legend;
}
